import React, { Component } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { connect } from 'react-redux';

import css from 'css';
import Container from 'partials/Container';
import { h3Styles } from 'partials/typography';
import RemoveIcon from 'images/RemoveIcon';
import MinifyIcon from 'images/MinifyIcon';
import { Button } from 'partials/formElements';
import { isValidEmail, msg } from 'helpers';

import {
    setBookingProgressCollapsedValue,
    setBookingVisibility,
    clearBooking,
    setBookingStep,
    setCartCollapsedValue,
    setCheckoutVisibility
} from 'store';

class BookingProgress extends Component {

    onNextClick() {
        const { step, timeSlot, contactDetails } = this.props.booking;

        if(step === 2 && !timeSlot) return alert('Select time slot');

        if(step === 3 && (!contactDetails.firstName || !contactDetails.lastName || !contactDetails.phone || !isValidEmail(contactDetails.email))) return alert(msg('provideContactDetails'));

        this.props.setBookingStep(step+1);
    }

    render() {
        const { visible, step, meetingType, timeSlot, contactDetails, files } = this.props.booking;
        const { reference } = this.props;

        if(!meetingType) return null;

        //console.log(contactDetails);

        return (
            <Wrapper reference={reference} currentStep={step} visible={visible}>
                <Container flex>
                    <StepLink currentStep={step} step={2} visible={visible} /*onClick={() => (step > 2 && step < 6) ? onStepChange(2) : null}*/ >
                        <label>Møteform</label>
                        <div>{meetingType}</div>
                        {reference && <a onClick={() => this.props.setBookingStep(1)}>Endre</a>}
                    </StepLink>
                    <StepLink currentStep={step} step={3} visible={visible} /*onClick={() => (step > 3 && step < 6) ? onStepChange(3) : null}*/ >
                        <label>Tidspunkt</label>
                        <div>
                            {timeSlot && parseData(timeSlot.start) + ' ' + timeSlot._startTime + ' - ' + timeSlot._endTime}
                        </div>
                        {reference && <a onClick={() => this.props.setBookingStep(2)}>Endre</a>}
                    </StepLink>
                    {!reference &&
                        <StepLink currentStep={step} step={4} visible={visible} /*onClick={() => (step > 4 && step < 6) ? onStepChange(4) : null}*/ >
                            <label>Kontaktinfo</label>
                            <div className="personal-details">
                                {contactDetails.firstName} {contactDetails.lastName}<br/><span>{contactDetails.lastName ? ',' : ''}</span>
                                {contactDetails.phone}<br/><span>{contactDetails.phone ? ',' : ''}</span>
                                {contactDetails.email}
                            </div>
                        </StepLink>
                    }
                    {!reference &&
                        <StepLink currentStep={step} step={5} visible={visible} /*onClick={() => (step > 5 && step < 6) ? onStepChange(4) : null}*/ >
                            <label>Vedlegg</label>
                            {files.map((file, i) => {
                                return(
                                    <div key={i}>{file.fileName}</div>
                                )
                            })}
                        </StepLink>
                    }

                    {!visible &&
                        <MobileTrigger onClick={() => this.props.setBookingVisibility(true)}>
                            Din rådgivingstime
                        </MobileTrigger>
                    }

                </Container>

                {!visible &&
                    <MinifyButton onClick={() => {
                        this.props.setBookingProgressCollapsedValue(true);
                        this.props.setCheckoutVisibility(false);
                        this.props.setCartCollapsedValue(false);
                    }}>
                        Minimer <MinifyIcon color="#fff"/>
                    </MinifyButton>
                }

                {!visible &&
                    <CloseButton onClick={() => {
                        this.props.clearBooking();
                        this.props.setBookingStep(1);
                        this.props.setCheckoutVisibility(false);
                        this.props.setCartCollapsedValue(false);
                    }}>
                        Avbryt <RemoveIcon color="#fff"/>
                    </CloseButton>
                }

                {!visible &&
                    <div className="continue">
                        <Button outline white onClick={() => this.props.setBookingVisibility(true)}>Fullfør</Button>
                    </div>
                }

                {visible && step < 5 &&
                    <div className="continue">
                        <Button outline white onClick={this.onNextClick.bind(this)}>Neste</Button>
                    </div>
                }

                 

            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    booking: state.bookMeeting,
    cart: state.cart,
    checkout: state.checkout
});

const actions = {
    setBookingProgressCollapsedValue,
    setBookingVisibility,
    clearBooking,
    setBookingStep,
    setCartCollapsedValue,
    setCheckoutVisibility
}

export default connect(mapStateToProps, actions)(BookingProgress);

const parseData = date => {
    if(moment.isMoment(date)) {
        // if date comes from current "session" it will be a moment() instance
        return date.format('D. MMMM');
    } else {
        // if date comes from store (after reloading page) it will be a string so we need to parse it
        return moment(String(date).substring(0, 10), 'YYYY-MM-DD').format('D. MMMM');
    }
}

const Wrapper = styled.div`
    background: ${props => props.reference ? css.colors.main : css.colors.blue};
    padding:25px 0 0;
    display: flex;
    color:#fff;
    height:180px;

    @media(max-width: 767px) {
        height: ${props => !props.visible ? '80px' : ''};
        ${props => props.visible && props.currentStep < 5 ? 'display:none' : ''}
    }

    .container {
        padding-right:140px;
        ${props => props.reference && props.currentStep === 5 ? `padding-right:0px;` : ``}

        @media(max-width: 1000px) {
            flex-wrap: wrap;
            ${props => props.currentStep === 5 ? `
                padding-right:0;
                padding-left:0;
            ` : ``}
        }
    }

    ${props => props.currentStep === 5 && props.visible ? `
        @media(max-width: 1000px) {
            height:auto;
        }
    ` : ``}

    .continue {
        position: absolute;
        bottom:30px;
        right:30px;
        @media(max-width: 767px) {
            display: none;
        }
    }
`

const StepLink = styled.button`
    padding-top: 15px;
    padding-right:20px;
    min-height: 120px;
    width: 25%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    transition: border .2s ease-in-out;
    color: #fff;

    .personal-details {
        width: 170px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    @media(max-width: 1000px) {
        padding-top:0;
        min-height:auto;
        width:100%;
        .personal-details {
            width:100%;
        }
        ${props => !props.visible ? `
            &:nth-child(1) , &:nth-child(2) {
                display: inline-flex;
                width: auto;
            }
        ` : ``}
    }

    @media(max-width: 767px) {
        display:none!important;
    }

    label {
        ${h3Styles}
        margin-bottom: 15px;
        display: block;
        @media(max-width: 1000px) {
            display: none;
        }
    }

    div {
        color: #fff;
        margin-bottom: 15px;
        line-height: 1.4;
        text-align:left;
        overflow: hidden;
        overflow-wrap: break-word;
        word-wrap: break-word;
        word-break: break-word;
        hyphens: auto;
        span {
            display:none;
        }
        @media(max-width: 1000px) {
            margin-bottom: 0px;
            br {
                display: none;
            }
            span {
                display: inline;
                padding-right:20px;
            }
        }
    }

    a {
        cursor: pointer;
        text-decoration:underline;
    }

    ${props => props.currentStep >= props.step ? `
        //border-bottom: 4px solid ${css.colors.red};
    `:`` }

    ${props => props.step < props.currentStep ? `
        //cursor: pointer;
        &:hover {
            //border-bottom: 10px solid ${css.colors.red};
        }
    `:`` }

    ${props => props.currentStep === 6 ? `
        cursor: default;
        border: none;
        &:hover {
            border: none;
            label {
                color: ${css.colors.main};
            }
        }
    `:`` }

    ${props => props.currentStep === 5 && props.visible ? `
        @media(max-width: 1000px) {
            padding: 0;
            width: 100%;
            text-align: center;
            display: flex!important;
            justify-content: center;
            align-items: center;
            > div {
                text-align:center;
                margin-bottom:20px;
                br {
                    display: block;
                }
                span {
                    display: none;
                }
            }
            a {
                margin-bottom:20px;
            }
        }
    `:`` }
`

const CloseButton = styled.button`
    position: absolute;
    top:30px;
    right:30px;
    color:#fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    svg {
        margin-left: 10px;
        bottom: -1px;
        position: relative;
    }
`

const MinifyButton = styled.button`
    position: absolute;
    top:30px;
    right:130px;
    color:#fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    svg {
        margin-left: 10px;
        bottom: -1px;
        position: relative;
    }

    @media(max-width: 767px) {
        display:none;
    }
`

const MobileTrigger = styled.div`
    display: none;
    @media(max-width: 767px) {
        display: inline-block;
        cursor: pointer;
        padding-top:3px;
    }
`;


// WEBPACK FOOTER //
// ./src/partials/Booking/BookingProgress.js